<template>
  <div>
    <div v-if="table_views.length > 0" style="margin-bottom: 50px">
      <div style="display: flex; flex-direction: column; gap: 50px">
        <div v-for="(view, index) in table_views">
          <div style="display: flex; align-items: center; justify-content: space-between; gap: 10px;">
            <div style="display: flex; align-items: center; gap: 10px">
              <el-date-picker
                v-model="view.daterange"
                size="mini"
                type="daterange" range-separator="-"
                :start-placeholder="$t('base.start_time')"
                :end-placeholder="$t('base.end_time')"
                format="dd-MM-yyyy" :clearable="false"
                :picker-options="picker_options"
                :disabled="true">
              </el-date-picker>
              <el-select v-model="view.timeslot" size="mini" value="" placeholder="Chọn khung giờ" multiple
                         collapse-tags filterable>
                <el-option v-for="hour in Array(24).keys()" :key="hour" :label="`${hour} giờ`"
                           :value="hour"></el-option>
              </el-select>
              <el-select v-model="view.metric_keys" size="mini" value="" placeholder="Chọn chỉ số" filterable
                         multiple collapse-tags>
                <el-option v-for="i in auto_ads_filter" :key="i.camel_key" :value="i.camel_key"
                           :label="i.label"></el-option>
              </el-select>
            </div>
            <div>
              <el-button size="mini" icon="el-icon-download" @click="m__download_table_view_data_updated(view)">
              </el-button>
              <el-button size="mini" icon="el-icon-close" @click="m__remove_table_view(index)">
              </el-button>
            </div>
          </div>

          <el-table
            :key="JSON.stringify(view.metric_keys)"
            :data="m__computed_table_view_data(view)"
            :row-class-name="m__table_row_class_name"
            @sort-change="m__table_view_data_sort_change(view, $event)"
            style="margin-top: 20px" class="custom-table-view"
          >
            <el-table-column label="Khung giờ / Ngày" prop="hour" min-width="140px" fixed="left">
              <template slot-scope="scope">
                <div style="padding: 0">
                  <template v-if="scope.row.hour === null">
                    Tổng
                  </template>
                  <template v-else>
                    {{ scope.row.hour }} giờ
                  </template>
                </div>
              </template>
            </el-table-column>
            <template v-for="date in view.dateslot">
              <template v-for="metric in view.metric_keys">
                <el-table-column width="115px" :prop="`data.${date.unix}.${metric}`" sortable="custom">
                  <template slot="header" slot-scope="scope">
                    <div>
                      {{ date.label }}
                      <br>
                      {{ m__get_metric_label(metric, auto_ads_filter) }}
                    </div>
                  </template>
                  <template slot-scope="scope">
                    {{ m__get_table_views_data_v2_updated(scope.row.data, date, metric) | currency }}
                    <template v-if="scope.row.hour === null">
                      <br>
                      <strong style="font-size: 11px" class="text-danger">
                        {{
                          is_percent_of(m__get_table_views_data_v2_updated(scope.row.data, date, metric), view.total_metrics[metric], 2)
                        }}%
                      </strong>
                    </template>
                  </template>
                </el-table-column>
              </template>
            </template>
            <template v-for="metric in view.metric_keys">
              <el-table-column min-width="150px" class-name="!bg-gray-100" :prop="`total_metrics.${metric}`"
                               sortable="custom">
                <template slot="header" slot-scope="scope">
                  <div>
                    {{ m__get_metric_label(metric, auto_ads_filter) }} theo giờ
                  </div>
                </template>
                <template slot-scope="scope">
                  <template v-if="scope.row.hour === null">
                    {{ parseFloat(view.total_metrics[metric] ? view.total_metrics[metric].toFixed(2) : 0) | currency }}
                    <!--                    {{ view.total_metrics[metric] }}-->
                  </template>
                  <template v-else>
                    <div v-if="scope.row.total_metrics"
                         style="display: flex; align-items: center; justify-content: space-between; gap: 10px; padding-right: 5px">
                      <span>
                        {{
                          parseFloat(scope.row.total_metrics[metric] ? scope.row.total_metrics[metric].toFixed(2) : 0) | currency
                        }}
                        <!--                        {{ scope.row.total_metrics[metric] }}-->
                      </span>
                      <strong style="font-size: 11px" class="text-danger">
                        {{ is_percent_of(scope.row.total_metrics[metric], view.total_metrics[metric], 1) }}%
                      </strong>
                    </div>
                    <div v-else>
                      {{ 0 }}
                    </div>
                  </template>
                </template>
              </el-table-column>
            </template>
          </el-table>
        </div>
      </div>
    </div>

    <div style="display: flex; align-items: center; justify-content: space-between; gap: 10px; margin-bottom: 40px">
      <div style="display: flex; align-items: center; gap: 10px">
        <el-date-picker
          v-model="table_views_daterange"
          size="mini"
          type="daterange" range-separator="-"
          :start-placeholder="$t('base.start_time')"
          :end-placeholder="$t('base.end_time')"
          format="dd-MM-yyyy" :clearable="false"
          :picker-options="picker_options">
        </el-date-picker>
        <el-select v-model="table_views_timeslot" size="mini" value="" placeholder="Chọn khung giờ" multiple
                   collapse-tags filterable>
          <el-option v-for="hour in Array(24).keys()" :key="hour" :label="`${hour} giờ`" :value="hour"></el-option>
        </el-select>
        <el-select v-model="table_views_metric_keys" size="mini" value="" placeholder="Chọn chỉ số" filterable
                   multiple collapse-tags>
          <el-option v-for="i in auto_ads_filter" :key="i.camel_key"
                     :value="i.camel_key" :label="i.label"></el-option>
        </el-select>
        <el-button type="primary" size="mini" icon="el-icon-plus" :loading="loading.add_table_views"
                   @click="m__add_table_views()">
          Xem bảng dữ liệu
        </el-button>
      </div>
      <div>
        <el-button size="mini" @click="table_views = []">Xóa hết dữ liệu</el-button>
      </div>
    </div>
  </div>
</template>

<script>
import {orderBy as _orderBy} from 'lodash';
import {make_uuid} from '../../../addon/ads_function';
import {auto_ads_filter, picker_options} from '../../../addon/options';
import {fix_ads_mixins} from '../../../mixins/fix_ads';

export default {
  name: "component_table_view",

  mixins: [fix_ads_mixins],

  props: {
    shop: null,
    campaign_id: null,
    campaign_type: null
  },

  data() {
    return {
      auto_ads_filter: [
        {
          label: this.$t('base.daily_budget'),
          key: 'daily_budget',
          camel_key: 'daily_budget',
        },
        {
          label: this.$t('base.target_roas'),
          key: 'target_roas',
          camel_key: 'target_roas',
        },
        ...auto_ads_filter
      ],

      loading: {
        add_table_views: false,
        update_table_views: false
      },

      picker_options: picker_options,
      table_views: [],
      table_views_daterange: [new Date().getTime() - 24 * 60 * 60 * 1000 * 7, new Date().getTime()],
      table_views_timeslot: [...Array(24).keys()],
      table_views_metric_key: 'broad_gmv',
      table_views_metric_keys: ['broad_roi', 'broad_gmv'],
      temporary_table: {},
    }
  },

  methods: {
    m__table_row_class_name({row}) {
      if (row.hour === null) return '!bg-gray-100'
    },

    async m__download_table_view_data_updated(view) {
      const data = []

      const headers = ['Khung giờ / Ngày'];
      for (const date of view.dateslot) {
        for (const metric of view.metric_keys) {
          headers.push(`${date.label} ${this.m__get_metric_label(metric, this.auto_ads_filter)}`)
        }
      }
      for (const metric of view.metric_keys) {
        headers.push(`${this.m__get_metric_label(metric, this.auto_ads_filter)} theo giờ`)
        headers.push(`% ${this.m__get_metric_label(metric, this.auto_ads_filter)} theo giờ`)
      }

      data.push(headers)

      for (const item of view.data.filter(i => i.hour === null || view.timeslot.includes(i.hour))) {
        const row = item.hour === null ? ['Tổng'] : [`${item.hour} giờ`]

        for (const date of view.dateslot) {
          for (const metric of view.metric_keys) {
            row.push(this.m__get_table_views_data_updated(item.data, date, metric))
          }
        }

        for (const metric of view.metric_keys) {
          if (item.hour === null) {
            row.push('')
            row.push('')
          } else {
            row.push(parseFloat(item.total_metrics[metric] ? item.total_metrics[metric].toFixed(2) : 0))
            row.push(this.is_percent_of(item.total_metrics[metric], view.total_metrics[metric], 1) + '%')
          }
        }

        data.push(row)
      }

      const filename = `bao cao theo khung gio - campaign ${this.campaign_id}.xlsx`
      const response = await this.$http.post(this.API.URL_API_SRV_2 + '/mipee/export_excel', {
        filename,
        data: data
      }, {
        ...this.cf(),
        responseType: 'blob'
      })
      const url = window.URL.createObjectURL(new Blob([response.body]))
      const link = document.createElement('a')
      link.href = url
      link.setAttribute('download', filename)
      document.body.appendChild(link)
      link.click()
    },

    async m__download_table_view_data(view) {
      const data = []

      const headers = ['Khung giờ / Ngày'];
      for (const date of view.dateslot) {
        headers.push(date.label)
      }

      data.push(headers)

      for (const hour of view.timeslot) {
        const row = [`${hour} giờ`]

        for (const date of view.dateslot) {
          for (const item of view.data) {
            if (item.unix !== date.unix) continue
            const hour_found = item.data.find(i => i.hour === hour)
            if (hour_found) row.push(hour_found.total)
          }
        }

        data.push(row)
      }

      const filename = `bao cao theo khung gio - campaign ${this.campaign_id}.xlsx`
      const response = await this.$http.post(this.API.URL_API_SRV_2 + '/mipee/export_excel', {
        filename,
        data: data
      }, {
        ...this.cf(),
        responseType: 'blob'
      })
      const url = window.URL.createObjectURL(new Blob([response.body]))
      const link = document.createElement('a')
      link.href = url
      link.setAttribute('download', filename)
      document.body.appendChild(link)
      link.click()
    },

    m__remove_table_view(index) {
      this.table_views.splice(index, 1)
    },

    m__get_table_views_data_updated(data, date, metric) {
      const date_found = data.find(i => i.unix === date.unix)
      if (date_found && date_found.metrics && date_found.metrics[metric]) {
        return parseFloat(date_found.metrics[metric] ? date_found.metrics[metric].toFixed(2) : 0)
      }

      return 0
    },

    m__get_table_views_data_v2_updated(data, date, metric) {
      const date_found = data[date.unix]
      if (date_found && date_found[metric]) {
        return parseFloat(date_found[metric] ? date_found[metric].toFixed(2) : 0)
      }

      return 0
    },

    m__get_table_views_data(data, date, hour) {
      const date_found = data.find(i => i.unix === date.unix)
      if (date_found) {
        const hour_found = date_found.data.find(i => i.hour === hour)
        if (hour_found) return parseFloat(hour_found.total ? hour_found.total.toFixed(2) : 0)
      }

      return 0
    },

    m__table_view_data_sort_change(view, event) {
      const {
        prop,
        order
      } = event
      view.sort_option.order = order
      view.sort_option.prop = prop
    },

    m__computed_table_view_data(view, data_key = 'data_v2') {
      const source = view[data_key].filter(i => i.hour === null || view.timeslot.includes(i.hour))
      let hour_parts = source.filter(i => i.hour !== null)
      const total_parts = source.filter(i => i.hour === null)

      if (view.sort_option.order) {
        view.sort_option.order === 'ascending' && (hour_parts = _orderBy(hour_parts, [view.sort_option.prop], ['asc']))
        view.sort_option.order === 'descending' && (hour_parts = _orderBy(hour_parts, [view.sort_option.prop], ['desc']))
      }

      return [...hour_parts, ...total_parts]
    },

    async m__add_table_views() {
      if (!this.table_views_metric_keys.length) {
        this.ntf_w('Vui lòng chọn chỉ số')
        return
      }

      if (!this.table_views_timeslot.length) {
        this.ntf_w('Vui lòng chọn khung giờ')
        return
      }

      this.loading.add_table_views = true

      try {
        const response = await this.$http.post(this.API.URL_API_SRV_2 + '/mipee/shopee_ads/get_shopee_ads_detail_by_hour/updated', {
          shop_id: this.shop._id,
          campaign_id: this.campaign_id,
          campaign_type: this.campaign_type,
          metric_key: this.table_views_metric_key,
          metric_keys: this.table_views_metric_keys,
          timeslot: this.table_views_timeslot,
          start_time: this.dayjs(new Date(this.table_views_daterange[0])).unix(),
          end_time: this.dayjs(new Date(this.table_views_daterange[1])).unix()
        }, this.cf())

        if (response && response.body && response.body.data) {
          const data = response.body.data
          data.key = make_uuid()
          data.sort_option = {
            order: null,
            prop: null,
          }
          data.daterange = [this.dayjs(data.start_time * 1000).toDate(), this.dayjs(data.end_time * 1000).toDate()]
          this.table_views.push(data)

          // this.m__computed_table_view_data(data)
        }
      } catch (e) {
        console.error(e)
        this.ntf_w('Đã có lỗi xảy ra')
      } finally {
        this.loading.add_table_views = false
      }
    },
  }
}
</script>



// WEBPACK FOOTER //
// src/pages/pas/component/component_table_view.vue